/**
 * Decisions app — /apps/decisions/*
 *
 * One job: the record, readable. Every memorialized decision in the
 * workspace, browsable and shareable — each decision is a URL you can
 * send when someone asks "why?". Read-only: recording happens where
 * decisions happen (published sessions, approved lists, gated reorders,
 * manual entries in the full Decision Log workbench).
 */

import { Navigate, Route, Routes } from 'react-router-dom';
import { getAppDefinition } from '../registry';
import { RequireAppAccess } from '../RequireAppAccess';
import DecisionLogScreen from './DecisionLogScreen';
import DecisionDetailScreen from './DecisionDetailScreen';

export default function DecisionsApp() {
  const app = getAppDefinition('decisions')!;
  return (
    <RequireAppAccess app={app}>
      <Routes>
        <Route index element={<DecisionLogScreen />} />
        <Route path=":decisionId" element={<DecisionDetailScreen />} />
        <Route path="*" element={<Navigate to="/apps/decisions" replace />} />
      </Routes>
    </RequireAppAccess>
  );
}
